/**
 * Single source of truth for the Connections (Canary) badge-photo URL.
 *
 * Uses the side CDN (supports the `fullsize` flag) that all Canary avatars
 * already load from -- extracted so the URL isn't duplicated across the chart
 * components and the leader dropdown.
 */
export const getBadgeUrl = (login: string): string => `https://cdn.prod.badgephotos.side.amazon.dev/?login=${login}&fullsize=false`;
